export default __webpack_public_path__ + "static/media/Dice-7.02e24d4f.png";